import { Component } from '@angular/core';

@Component({
  selector: 'app-design-system',
  standalone: true,
  imports: [],
  templateUrl: './design-system.component.html',
  styleUrl: './design-system.component.scss'
})
export class DesignSystemComponent {

}
